<small class="debug">{{me}}</small>
<div class="animSettings">
    <app-setting-toggle-group
        icon="animation"
        title="animation"
        name="animation"
        ariaLabel="Animation Mode"
        [options]="animationOptions"
        [hideSingleSelectionIndicator]="false"
        [ngModel]="animationMode"
        (selectionChange)="onChangeAnimationMode($event)">
    </app-setting-toggle-group>

    @if (animationMode === 'override') {
        <div class="animation-preview">
            <app-block-animation-preview></app-block-animation-preview>
        </div>
        <br/>
    }
    <!-- @if (showAnimationEngine === 1) {
        <div class="row">
            <div fxLayout="row" class="d-flex-center">
                <button mat-icon-button class="mini-button" matTooltip="{{'general.copyAnimation' | transloco}}"
                    (click)="copyAnimation();">
                    <mat-icon>content_copy</mat-icon>
                </button>
                <button mat-icon-button class="mini-button" matTooltip="{{'general.pasteAnimation' | transloco}}"
                    (click)="pasteAnimation();" [disabled]="!animationClipboard">
                    <mat-icon>content_paste</mat-icon>
                </button>
                @if (isHostDevOrLocal) {
                    <button mat-icon-button class="mini-button" (click)="devExportConfig()">
                        <mat-icon>cloud_download</mat-icon>
                    </button>
                }
            </div>
        </div>
    } -->
</div>